import React, { useState, useEffect, useCallback, useContext } from 'react';
import { useAuth } from "react-oidc-context";
import { API_URL } from '../../config';
import { GameContext } from '../../GameContext';

const VocabMultipleChoice = React.memo(({gameKey, onAnswerSelected, onDataFetched}) => {
  const auth = useAuth();
  const token = auth.user?.access_token;
  const [gameState, setGameState] = useState('initial'); // 'initial', 'playing', 'finished'
  const [question_word, setWord] = useState('');
  const [choices, setChoices] = useState([]);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [correctAnswer, setCorrectAnswer] = useState('');
  const [isCorrect, setIsCorrect] = useState(false);
  const gameStartedRef = React.useRef({});
  const { languageData, learnedWords, updateLearnedList } = useContext(GameContext);

  const startGame = useCallback(async () => {
    console.log('Game started in MC component with gameKey:', gameKey);
    setGameState('playing');
    setSelectedAnswer(null);
    setCorrectAnswer('');
    setIsCorrect(false);
    
    try {
      const response = await fetch(`${API_URL}/api/get-MC-vocab-question`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
                    vocab_list: languageData,
                    learned_words: learnedWords
                })
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setWord(data.question_word);
      setChoices(data.choices);
      onDataFetched(data.result);
    } catch (error) {
      console.error('Error fetching word:', error);
    }
  }, [gameKey, onDataFetched]);

  useEffect(() => {
    // Only start the game if we haven't already started it for this gameKey
    if (!gameStartedRef.current[gameKey]) {
      console.log(`Starting game for gameKey: ${gameKey}`, {
        timestamp: new Date().toISOString(),
        strictMode: process.env.NODE_ENV === 'development'
      });
      gameStartedRef.current[gameKey] = true;
      startGame();
    }
    // Cleanup function to remove the gameKey from our ref when the component unmounts
    // or when gameKey changes
    return () => {
      delete gameStartedRef.current[gameKey];
    };
  }, [gameKey, startGame]); 

  const checkAnswer = useCallback(async (answer) => {
    console.log('Checking answer:', answer);

    try {
      console.log('Api url chec vocab answer- ', API_URL)
      const response = await fetch(`${API_URL}/api/check_vocab_answer`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          vocab_list: languageData,
          learned_words: learnedWords,
          word: question_word,
          answer: answer
        }),
      });
      await delay(100);
      setSelectedAnswer(answer);
      if (onAnswerSelected) onAnswerSelected(true);

      if (!response.ok) {throw new Error('Network response was not ok');}

      const data = await response.json();
      console.log('Data received from backend:', data);
      setIsCorrect(data.isCorrect);
      setCorrectAnswer(data.correctAnswer);
      setGameState('finished');

      let updatedList = data.learnedWordList;
    if (!Array.isArray(updatedList)) {
        console.log("Converting fake array back to real array");
        updatedList = Object.values(updatedList);
        }

      updateLearnedList(updatedList);
      
      //setStructuredResult(data.result);
      if (data.result) onDataFetched(data.result);

    } catch (error) {
      console.error('Error checking answer:', error);
    }
  }, [question_word, onAnswerSelected, onDataFetched]);


  const getButtonClass = (option) => {
    if (gameState !== 'finished') return 'btn-outline-primary';
    if (option === correctAnswer) return 'btn-success custom-color';
    if (option === selectedAnswer && !isCorrect) return 'btn-danger';
    return 'btn-outline-primary';
  };

  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  return (
    <div className="container mt-5">
      {gameState !== 'initial' && (
        <div>
          <h3>{question_word}</h3>
          <div className="mt-3 d-flex flex-column">
            {choices.map((option, index) => (
              <button
                key={index}
                className={`btn w-100 mb-2 ${getButtonClass(option)}`}
                style={{ maxWidth: '400px' }}
                onClick={() => gameState === 'playing' && checkAnswer(option)}
                disabled={gameState === 'finished'}
              >
                {option}
              </button>
            ))}
          </div>
        </div>
      )}
      
    </div>
  );
});


export default VocabMultipleChoice;